module.exports = __webpack_public_path__ + "media/images/my_apps/ohap_my_apps_muscles_banner-f76f703af7531823997305b2cb4e3cc2.png";